module.exports = __webpack_public_path__ + "group-15.svg?2f71ac0f919f21f3f4c1204c1be560ed";